import { Stack, useTheme } from "@mui/material";
import PageHeadSearch from "./page-head-search";
import PageHeadNotifications from "./page-head-notifications";
import PageHeadComments from "./page-head-comments";
import PageHeadTreeview from "./page-head-treeview";
import { Img } from "react-image";
import { cacheService, userService } from "../../../../Core/Api/services";
import { PlatformResourceType } from "../../../../Core/Api/Types/platform-resource-type";
import PageHeadOrder from "./page-head-order";
import { useMemo } from "react";
import { PlatformMode } from "../../../../Core/Api/Types/platform-mode";
import PageHeadTimetool from "./page-head-timetool";
import { UserHasAcl, UserHasLicence } from "../../../../Utils/helpers";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import { Licences } from "../../../../Core/Api/Types/licences";

interface PageHeadActionsProps {
  drawerOpen?: boolean;
  searchOpen: boolean;
  setSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const LogoCustomer: React.FC = () => {
  const theme = useTheme();

  return (
    <Img
      src={[
        userService.GetResourceUrl(
          theme.palette.mode === "dark" ? PlatformResourceType.LogoV4dark : PlatformResourceType.LogoV4light
        ),
      ]}
      height="28px"
      style={{ objectFit: "contain" }}
      loader={<></>} // Used while loading
      unloader={<></>} // Used when image not loaded like 404
      container={(children) => {
        // <img> will be rendered as child of
        return (
          <Stack height="100%" justifyContent="center" ml={1}>
            {children}
          </Stack>
        );
      }}
    />
  );
};

const PageHeadActions: React.FC<PageHeadActionsProps> = (props) => {
  const user = cacheService.GetUserInfo();
  const platformMode = cacheService.GetPlatformMode();
  const isDrive = useMemo(() => platformMode === PlatformMode.Browser, [platformMode]);
  const aclTimetool = UserHasAcl(AclTypes.aclTimetool);
  const licenceTimetool = UserHasLicence(Licences.TimeTool);

  const { drawerOpen, searchOpen, setSearchOpen } = props;

  return (
    <Stack
      direction="row"
      alignSelf="stretch"
      alignItems="stretch"
      sx={{
        flexShrink: 0,
        flexGrow: 0,
        ...(drawerOpen && {
          filter: "blur(6px)",
        }),
      }}
      onClick={() => searchOpen && setSearchOpen(false)}
    >
      <Stack direction="row" gap={1} py={1} pr={2}>
        <PageHeadSearch searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
        {!user?.isExternalAccessSpecific && (
          <>
            {!isDrive && <PageHeadTreeview />}
            {aclTimetool && licenceTimetool && <PageHeadTimetool />}
            <PageHeadComments />
            <PageHeadNotifications />
            <LogoCustomer />
          </>
        )}
      </Stack>
      {platformMode !== PlatformMode.Adam && !user?.isExternalAccessSpecific && <PageHeadOrder />}
    </Stack>
  );
};

export default PageHeadActions;
